import { InstallPrompt } from "@/components/InstallPrompt";
import { FeedbackButton } from "@/components/FeedbackButton";
import DesktopNav from "./DesktopNav";
import BottomTabBar from "./BottomTabBar";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bone font-sans">
      <InstallPrompt />
      <DesktopNav />
      <main className="flex-1 flex flex-col relative pb-16 md:pb-0">
        {children}
      </main>
      <BottomTabBar />
      <FeedbackButton />
    </div>
  );
}
